import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import { Button } from 'reactstrap'
import * as RootConstants from '../../../constants'
import { editModal } from '../actions'

export class EditCell extends GridCell {
  public render() {
    const editType = this.props.dataItem.start_datetime > new Date() ? RootConstants.EDIT : RootConstants.CLONE
    return <td>
      <Button className="secondary-button"
              onClick={(() => this.props.dataItem.dispatch(editModal(this.props.dataItem, editType)))}
              id={editType}>
              {editType}
      </Button>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotions/render/edit_cell.tsx